<template>
  <v-navigation-drawer
      app
      clipped
      dark
      permanent
      :mini-variant.sync="miniVersion"
      v-model="drawer"
      @update:mini-variant="onUpdateMiniVariant"
  >
    <v-list dense>
      <v-list-item
          link
          v-for="item in items"
          :key="item.title"
          :to="item.path"
      >
        <v-list-item-icon>
          <v-icon>{{ item.meta.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $tc(item.meta.title, 2) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: 'Sidebar',
  props: {
    mini: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    drawer: true,
    miniVersion: true
  }),
  watch: {
    mini(value) {
      this.miniVersion = value;
    },
    '$route'() {
      setTimeout(() => this.onUpdateMiniVariant(), 1500);
    }
  },
  methods: {
    onUpdateMiniVariant() {
      this.$emit('updatedMiniVariant')
    }
  },
  mounted() {
  }
}
</script>